import {
  SERVICE_ITEM_TITLE_CURRENT_PRO_PURCHASING_PRO,
  SERVICE_ITEM_TITLE_CURRENT_PRO_PURCHASING_PRO_RENEWAL,
  SERVICE_ITEM_TITLE_PURCHASING_PRO,
  SERVICE_ITEM_TITLE_PURCHASING_PRO_RENEWAL
} from '../constants/Codes';
import {COUNTRY_CODE_US} from '../constants/Countries';

export default function orderItemsIncludeProItem(orderItems) {
  let includesProItem = false;

  orderItems && orderItems.forEach((orderItem) => {
    const orderItemIsServiceItem = orderItem.service_item;

    if (orderItemIsServiceItem) {
      const orderItemTitleCode = orderItem.service_item.title_code;

      if (orderItemTitleCode === SERVICE_ITEM_TITLE_PURCHASING_PRO_RENEWAL || orderItemTitleCode === SERVICE_ITEM_TITLE_PURCHASING_PRO ||
        orderItemTitleCode === SERVICE_ITEM_TITLE_CURRENT_PRO_PURCHASING_PRO || orderItemTitleCode === SERVICE_ITEM_TITLE_CURRENT_PRO_PURCHASING_PRO_RENEWAL) {
        includesProItem = true;
      }
    }
  });

  return includesProItem;
}

export function getPiecesAtChosenChunkSize(quantity, chunkSize) {
  return Math.floor(quantity / chunkSize);
}

export function getChunkSizeOfRemainingPieces(quantity, piecesAtChosenChunkSize, chunkSize) {
  return quantity - (piecesAtChosenChunkSize * chunkSize);
}

export function hideTax(shippingCountry) {
  return !!shippingCountry && shippingCountry === COUNTRY_CODE_US;
}
